// components/subscription/PlanGrid.jsx
import SubscriptionCard from "./SubscriptionCard";

const PlanGrid = ({
  plans = [],
  currentPlan,
  onPlanClick,
  currentCategoryId,
}) => {
  if (!plans || plans.length === 0) {
    return (
      <div className="p-4 bg-white rounded-xl shadow-sm text-gray-600">
        پلنی برای نمایش وجود ندارد.
      </div>
    );
  }

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
      {plans.map((plan, idx) => {
        const isSameCategory =
          String(plan.category?._id) === String(currentCategoryId);

        const isCurrent = isSameCategory && plan.key === currentPlan;

        return (
          <SubscriptionCard
            key={plan.key || plan.id || idx}
            {...plan}
            isCurrent={isCurrent}
            disabled={
              plan.key === "free" &&
              isSameCategory &&
              currentPlan !== "free" &&
              !!currentPlan
            }
            onClick={
              plan.onClick
                ? plan.onClick
                : onPlanClick
                  ? () => onPlanClick(plan)
                  : undefined
            }
          />
        );
      })}
    </section>
  );
};

export default PlanGrid;
